
































import { computed, defineComponent, PropType, toRefs } from '@nuxtjs/composition-api'

const dChip = defineComponent({
  name: 'DChip',
  props: {
    label: {
      type: String as PropType<string>,
      default: ''
    },
    iconPath: {
      type: String as PropType<string>,
      default: ''
    },
    maxLabelWidth: {
      type: String as PropType<string>,
      default: 'auto'
    },
    hasIcon: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  setup(props) {
    const { maxLabelWidth, label } = toRefs(props)
    const computedStyle = computed(() => {
      return {
        maxWidth: maxLabelWidth.value
      }
    })
    const firstLetter = computed(() => label.value.slice(0, 1))
    return {
      computedStyle,
      firstLetter
    }
  }
})
export default dChip
